<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Daily Payments</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" xs="12" sm="3" md="3">
            <v-autocomplete name="dailyQueryPaymentMode" dense outlined v-model="PaymentMode" :items="accounts"
              label="Payment Mode" item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="3" md="3">
            <v-autocomplete name="dailyQuerySoldBy" dense outlined v-model="SoldBy" :items="users" label="Sold By"
              item-text="name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="3" md="3">
            <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
          </v-col>

          <v-col cols="3">
            <v-btn color="primary" @click="getRecords" :loading="loader">Filter</v-btn>
          </v-col>

          <v-col v-if="hideTotals != 'Y' && hideTotalSales != 'Y'" cols="12" md="3" class="subtitle-2 text--primary">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Total Payments:</td>
                    <td>{{ TotalPayments | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col cols="12" md="3">
            <v-btn text @click="printPayments" color="primary">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon> Print List
            </v-btn>
          </v-col>

          <v-col cols="12" md="3">
            <download-excel :data="AllPayments" :fields="fields" name="Payments Report">
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
          </v-col>
        </v-row>

        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-text-field label="Search" v-model="search"></v-text-field>
            <!-- start of table -->
            <v-data-table dense :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers"
              :items="AllPayments" :search="search">
              <template v-slot:item.Amount="{ item }">{{
                item.Amount | currency
              }}</template>

              <template v-slot:item.date="{ item }">
                <span>{{ formatDateTime(item.date) }}</span>
              </template>

              <!-- action template -->
              <template v-slot:item.InvoiceId="{ item }">
                <v-btn color="accent" text :to="`/pos/sale-details/${item.InvoiceId}`">
                  View Invoice
                  <v-icon right>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->

            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <!-- pdf preview -->
        <pdf-preview ref="pdfPreview"></pdf-preview>
        <!-- end -->

        <v-row>
          <v-divider></v-divider>
        </v-row>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
export default {
  data() {
    return {
      search: null,
      pageItems: 1000,
      loader: false,
      SoldBy: null,
      PaymentMode: null,
      date: new Date().toISOString().substr(0, 10),
      users: [],
      accounts: [],
      headers: [
        { text: "Doc No.", value: "InvoiceId" },
        { text: "Customer", value: "customer.Name" },
        { text: "Amount", value: "Amount" },
        { text: "Payment Mode", value: "Account.Name" },
        { text: "Remarks", value: "PaymentRemarks" },
        { text: "Posted By", value: "Seller.name" },
        { text: "Date", value: "date" },
      ],
      returnHeaders: [
        { text: "Customer", value: "ocrd" },
        { text: "Amount", value: "SumApplied" },
        { text: "Payment Mode", value: "oact" },
        { text: "Date", value: "DocDate" },
      ],
      AllPayments: [],
      TotalPayments: 0,
      returnPayments: [],
      TotalReturns: null,
      fields: {
        CustomerName: "customer.Name",
        Amount: "Amount",
        PaymentMode: "Account.Name",
        Cashier: "Seller.name",
        Date: {
          field: "date",
          callback: (value) => {
            if (!value) return "";
            const date = new Date(value);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
          }
        }
      },
    };
  },
  computed: {
    hideTotalSales() {
      return localStorage.getItem("HideTotalSales");
    },
    hideTotals() {
      return localStorage.getItem("HideDebtorsTotal");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
  },
  methods: {
     formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    setDate(date) {
      this.date = date;
    },
    printPayments() {
      var storeId = localStorage.getItem("store_id");

      var url = "";
      if (this.PaymentMode == null) {
        url = "/print-sale-payments/" + storeId;
      }

      if (this.PaymentMode != null) {
        var accountId = this.PaymentMode;
        url = `/print-sale-payments/${storeId}/${accountId}`;
      }

      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    getRecords() {
      const storeId = this.activeStore;
      const self = this;
      const data = {
        store_id: storeId,
        AccountId: self.PaymentMode,
        SoldBy: self.SoldBy,
        StartDate: self.date,
        EndDate: "",
      };

      const url = `/sale-payments-report`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.AllPayments = res.ResponseData.payments;
            self.TotalPayments = res.ResponseData.TotalAmountPaid;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    checkExpiry() {
      const self = this;
      const userId = this.subscriberId;
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          console.log(res.ResponseData, "res g");
          if (res.ResponseData.expiryStatus == 1) {
            self.$router.push("/inactive-account");
          }
        })
        .catch(() => { });
    },
  },
  created() {
    Promise.all([
      this.checkExpiry(),
      this.getRecords(),
      this.getAccounts(),
      this.getUsers(),
    ]);
  },
};
</script>

<style lang="scss" scoped></style>